import { render, staticRenderFns } from "./JoinUsForm.vue?vue&type=template&id=650ec626&scoped=true"
import script from "./JoinUsForm.vue?vue&type=script&lang=js"
export * from "./JoinUsForm.vue?vue&type=script&lang=js"
import style0 from "./JoinUsForm.vue?vue&type=style&index=0&id=650ec626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ec626",
  null
  
)

export default component.exports